const state = {
    //Отображает/неотображает модальное окно    
    modalOpen: false,
    /** 
     * Компонент с данными, передаваемый в модальное окно 
     * для отображения (может содержать объект данных, включая компонент и т.д.) 
    */
    modalComponent: null
};

const getters = {
    modalOpen: state => {
      return state.modalOpen
    },
    modalComponent: state => {
      return state.modalComponent
    }
};

const mutations = {
    modalComponent: (state, payload) => {
        return state.modalComponent = payload
    },
    modalOpen: state => {
      return state.modalOpen = true
    },
    modalClose: state => {
      return state.modalOpen = false
    }
};

const actions = {
  modalOpen({commit}, modalData) {
    commit('modalOpen')
    commit('modalComponent', modalData)
  },
  modalClose({commit}) {
    commit('modalClose')
    commit('modalComponent', null)
  }
};

export default {
    state,
    getters,
    mutations,
    actions
}